var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.timers.pollTimer.pollId === _vm.pollId)?_c('div',[_vm._v(" "+_vm._s(_vm.getTimer)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }